var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-container",class:_vm.rootClass},_vm._l((_vm.items),function(item){return _c(item.component,_vm._b({key:item.key,tag:"component",attrs:{"item":item},on:{"remove":_vm.onItemRemove}},'component',item.props,false))}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43986ac5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/modals/components/ModalContainer.vue
// module id = null
// module chunks = 